import { HttpClientHistoryRepository } from "@data/repositories/index";
import { GetClientHistoryUseCase } from "@useCases/index";
import { api } from "@data/api";
import { Client } from "@domain/models/Client";

export default function useClientHistory() {
  const getClientHistory = async (clientId: Client["id"]) => {
    const useCase = new GetClientHistoryUseCase(new HttpClientHistoryRepository(api));

    return useCase.execute(clientId);
  };
  return {
    getClientHistory,
  };
}
